import { getQuotationCategory } from '@/api/quotation';
import { formatTimeStr, generateUUID, timeFormat } from '@/utils/other';
import BaseListClass from './BaseListClass';
import ListClass from './ListClass';
import RequestApi from './RequestApiClass';

type IGetSolutionParams = ISolution.IModel.IGetSolutionParams;
type ISearchSolution = ISolution.IRequest.ISearchSolution;
type ISolutionInfo = ISolution.IResponse.ISolutionInfo;
type IClauseOption = ISolution.IClauseOption;
type ICategoryInfo = IQuotation.IResponse.ICategoryInfo;
type IUpdateQuotationParams = ISolution.IRequest.IUpdateQuotationParams;

const defaultParams: IGetSolutionParams = {
  pageindex: 1,
  pagesize: 100,
};

const calculateManDay = (items: ISolution.IClause[]) => {
  if (items.length > 0) {
    const result = items.reduce((total, clauseItem) => {
      return total + clauseItem.manDay;
    }, 0);
    return Number(result.toFixed(1));
  } else {
    return 0;
  }
};
export default class SolutionListClass extends BaseListClass<ISolutionInfo> {
  public requireClauses: IClauseOption[] = [];
  public categorys: ICategoryInfo[] = [];
  public requireCategorys: ICategoryInfo[] = [];
  public $requestParams: ISearchSolution = { ...defaultParams };
  public detailParams: ISearchSolution = {
    returnComment: true,
  };
  private $solutionForCreate: IUpdateQuotationParams | undefined = undefined;
  get solutionForCreate() {
    return this.$solutionForCreate;
  }
  constructor() {
    super({
      list: new ListClass<ISolutionInfo>(),
      requestApi: new RequestApi('Quotation'),
    });
  }
  public requestChangeItem<Q>(
    solution: ISolutionInfo,
    params: Q,
  ): Promise<string> {
    return new Promise((reslove, reject) => {
      this.requestApi.postData(this.requestApi.createUrlById(solution.id), params)
        .then((res) => {
          this.requestDetail({
            id: solution.id,
          }).then((res2) => {
            reslove(res2);
          }).catch((err) => {
            reject(err);
          });
        })
        .catch((err) => {
          reject(err.message);
        });
    });
  }
  public requestCategorys(): Promise<string> {
    return new Promise((reslove, reject) => {
      getQuotationCategory({
        active: true,
      }).then((res) => {
        reslove(res.message);
        this.categorys = res.data;
        this.setRequireCategorys(res.data);
      }).catch((error) => {
        reject(error.message);
      });
    });
  }
  public checkItem(solution: ISolutionInfo) {
    const result: boolean[] = [];
    ['id', 'requirementId', 'projectId', 'status'].forEach((key) => {
      if (this.$requestParams[key as keyof ISearchSolution]) {
        result.push(
          solution[key as keyof ISolutionInfo] === this.$requestParams[key as keyof ISearchSolution],
        );
      }
    });
    if (this.$requestParams.title) {
      result.push(solution.title.includes(this.$requestParams.title));
    }
    return result.every((value) => value);
  }
  public convertData(solutions: ISolutionInfo[]): ISolutionInfo[] {
    return solutions.map((solution) => ({
      ...solution,
      calculateManDay: calculateManDay(solution.items),
      effectiveDate: formatTimeStr(solution.effectiveDate),
      startDate: formatTimeStr(solution.startDate),
      endDate: formatTimeStr(solution.endDate),
      createdOn: timeFormat(solution.createdOn),
    }));
  }
  public initRequestParams() {
    this.$requestParams = { ...defaultParams };
  }
  public createSolution(requirementId: string = '') {
    const newSolution: IUpdateQuotationParams = {
      title: '',
      requirementId,
      items: [],
      startDate: '',
      endDate: '',
      workDays: 0,
      effectiveDate: '',
      effectiveDays: 5,
    };
    newSolution.items = this.requireClauses.map((clauses) => {
      return {
        id: generateUUID(),
        ...clauses,
      };
    });
    this.$solutionForCreate = newSolution;
    return newSolution;
  }
  public updateRequireClauses(requireCategorys: ICategoryInfo[]) {
    this.requireClauses = requireCategorys.map((category, index) => {
      return {
        categoryId: category.id,
        title: '',
        manDay: 0,
        index,
      };
    });
  }
  public setRequireCategorys(categorys: ICategoryInfo[]) {
    this.requireCategorys = categorys.filter((category) => {
      return category.isRequired;
    });
  }
}
export const solutionListInstance = new SolutionListClass();
